// extracted by mini-css-extract-plugin
export var body = "_ds-5";
export var closeButton = "_ds-f";
export var container = "_ds-1";
export var content = "_ds-2";
export var cta = "_ds-c";
export var ctaLabel = "_ds-b";
export var eyebrow = "_ds-3";
export var howTo = "_ds-6";
export var image = "_ds-e";
export var modal = "_ds-0";
export var socialButton = "_ds-d";
export var stepCard = "_ds-8";
export var stepLabel = "_ds-a";
export var stepNumber = "_ds-9";
export var steps = "_ds-7";
export var title = "_ds-4";